export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="count/count_plus">
<path id="Union" d="M17.8003 14.1997L24.1196 14.2007V17.8003H17.8003L17.7993 24.1196H14.1997V17.7993H7.88037V14.1997H14.1997L14.2007 7.88037H17.8003V14.1997Z"/>
</g>
</svg>
